module.exports = __webpack_public_path__ + "static/media/pict_logo.243f4a90.png";